import { GenericValueLabelType } from '@doc-abode/data-models';

/**
 * Finds a given object in an array of objects based on its internal value
 * @param valueToFind string to match on
 * @param arrayToSearch the array to look through
 * @returns GenericValueType if a match is made or undefined
 */
export function findByValue(
    valueToFind?: string,
    arrayToSearch?: GenericValueLabelType[],
): GenericValueLabelType | undefined {
    if (!arrayToSearch) {
        return undefined;
    }

    return arrayToSearch.find((availableType) => availableType.value === valueToFind);
}
